import { qs, listen } from "@fluorescent/dom";
import { emit } from "@/glow/events";

const selectors = {
  popupTrigger: "[data-popup-trigger]",
};

const informationPopup = node => {
  const listener = listen(node, "click", e => {
    const trigger = e.target.closest(selectors.popupTrigger);
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    const { modalContentId } = trigger.dataset;
    const content = modalContentId && qs(`#${modalContentId}`, node);

    if (!content) return;

    emit("modal:open", null, {
      modalContent: content,
    });
  });

  return { unload: () => listener() };
};

export default informationPopup;
